export enum PAYMENT_AGREEMENT_PERMISSIONS {
  PAYMENT_AGREEMENT_VIEW = 'PAYMENT_AGREEMENTVIEW',
  PAYMENT_AGREEMENT_WRITE = 'PAYMENT_AGREEMENTWRITE',
}
